import React from 'react'
import {Control, Errors} from 'react-redux-form'
import ArrowButton from '../../../common/button-arrow'
import {Row, Col, FormGroup, FormControl} from 'react-bootstrap'
import {saveStaffRewardSettings} from '../../../../actions/staff'

const AutoRedemptionDate = ({index, onDelete}) => {
  return (
    <div>

      <Row>
        <Col lg={12} className="autoredemption-date-col">
          <FormGroup>
            <Control
              model={`.autoredemption_dates[${index}]`}
              placeholder="dd/mm"
              pattern="\d\d/\d\d"
              component={FormControl}/>

            <Errors
              show={{
                touched: true,
                focus: false
              }}
              className="errors"
              model={`.autoredemption_dates[${index}]`}
              messages={{
                patternMismatch: 'Value does not match the required pattern'
              }}/>

            <Errors
              show={{
                touched: true,
                focus: false
              }}
              className="errors"
              model={`.autoredemption_dates[]`}
              messages={{
                [index]: 'Date is in invalid format'
              }}/>
          </FormGroup>

          <ArrowButton submit={false}
                       arrow={false}
                       onClick={() => onDelete(index)}>Delete</ArrowButton>
        </Col>
      </Row>
      <Row>
        <Col lg={12}>

        </Col>
      </Row>
    </div>
  )
};

export default AutoRedemptionDate


// WEBPACK FOOTER //
// ./src/components/admin/staff-reward/settings/autoredemption-date.jsx